export const ROOM_STAGE_BASE_SIZE = {
  WIDTH: 1_280,
  HEIGHT: 720
} as const;
